import { Circle, Fill, Stroke, Style } from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { OSM, Vector as VectorSource } from 'ol/source';

const map = {};
const blue = alpha => `RGBA(98, 123, 162, ${alpha})`;
let center = null;

map.settings = () => ({
  center: center || [0, 0],
  zoom: 3,
  projection: 'EPSG:4326',
  clickMargin: 5,
});

map.getPointStyle = () =>
  new Style({
    image: new Circle({
      radius: 4,
      fill: new Fill({ color: blue('0.7') }),
      stroke: new Stroke({ color: blue('0.5'), width: 10 }),
    }),
  });

map.createPoints = (locations) => {
  const features = [];

  locations.forEach((location) => {
    const feature = new Feature({
      geometry: new Point([location.city_longitude, location.city_latitude]),
      name: location.city_name,
      data: location.visits,
    });

    feature.setStyle(map.getPointStyle());
    features.push(feature);
  });

  center = [locations[0].city_longitude, locations[0].city_latitude];
  return features;
};

map.createVectorLayer = (data = null) => {
  const vectorSource = new VectorSource();

  if (data && data.length > 0) {
    vectorSource.addFeatures(map.createPoints(data));
  }

  return new VectorLayer({ source: vectorSource });
};

map.createOpenStreetLayer = () => new TileLayer({ source: new OSM() });

export default map;



// WEBPACK FOOTER //
// ./src/services/map/index.js